export const ActionTypes = {
  AUTH: 'AUTH',
  LOGOUT: 'LOGOUT',

  FETCH_ALL_USER: 'FETCH_ALL',
  SEARCH_USER: 'SEARCH_USER',
  CACHE_USER: 'CACHE_USER',
  CHANGE_USER_TAB: 'CHANGE_USER_TAB',

  FETCH_ALL_MESSAGES: 'FETCH_ALL_MESSAGES',
  POST_MESSAGE: 'POST_MESSAGE',

  FETCH_ALL_PERSONAL_NOTIFICATIONS: 'FETCH_ALL_PERSONAL_NOTIFICATION',
  POST_PERSONAL_NOTIFICATION: 'POST_PERSONAL_NOTIFICATION',
  UPDATE_PERSONAL_NOTIFICATION: 'UPDATE_PERSONAL_NOTIFICATION',
};
